<button
  type="button"
  class="fixed bottom-2 left-2 z-2147482100 flex items-center gap-1 rounded-full bg-black/40 px-2 py-0.5 text-[10px] font-medium text-white opacity-30 transition-opacity hover:opacity-100"
  aria-label="Change dev backend"
  (click)="open()">
  @if (hasOverride) {
    <span class="h-1.5 w-1.5 rounded-full bg-amber-400"></span>
  }
  <span>{{ shortLabel }}</span>
</button>
